import exceljs from "exceljs";
import { saveAs } from "file-saver";
//---------------------------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import {
    outsideHolidays, 
    getDatefromWeekNum, 
    outsideRoleCode, 
    round, 
    defaultEmptyPMNumber, 
    mimeTypeMap, 
    isDevMode, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function PMReport({ 
    filteredForms, 
    week, 
}){
    const user = useMyStore(state => state.user);
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const handlePMReport = () => {
        setShowLoader(true);
        const mainData = filteredForms
        .map(raw => ({
            ...raw[week], 
            email: raw.email, 
            userName: raw.userName.replace(/ {2}/g, " "), 
            outside: raw.outside, 
            outsideTimeCards: raw.outsideTimeCards
        }))
        //.filter(raw => raw.status === "Submitted")
        .map(raw => ({
            form: raw.form.map(r => r.workStatus !== "Work"?{
                data: [],
                id: r.id,
                overnight: false,
                status: r.status
            }:r), 
            email: raw.email, 
            userName: raw.userName.replace(/ {2}/g, " "), 
            outside: raw.outside, 
            outsideTimeCards: raw.outsideTimeCards
        }));
        const workbook = new exceljs.Workbook();
        workbook.creator = user.userName.replace(/ {2}/g, " ");
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true;
        for(let totalI = 0; totalI < 7; totalI++){
            const events = [];
            const worksheet = workbook.addWorksheet(
                getDatefromWeekNum(week, totalI)
            );
            worksheet.state = "visible";
            worksheet.properties.defaultColWidth = 22.57;
            const headerArr = ["Name", "Division", "Bess Project"];
            const maxlength = Math.max(...mainData.map(
                d => d.form[totalI].data.filter(
                    d => d.category !== "lunch"
                ).length
            ));
            headerArr.push(`PM Mob In Number`, `PM Mob In Regular`, `PM Mob In OT`, `PM Mob Out Number`, `PM Mob Out Regular`, `PM Mob Out OT`);
            for(let jobii = 0; jobii < maxlength; jobii++){
                headerArr.push(`PM ${jobii + 1} Number`, `PM ${jobii + 1} Regular`, `PM ${jobii + 1} OT`);
            }
            const rows = [];
            for(let z = 0;  z < mainData.length; z++){
                const arr = [];
                arr.push(mainData[z].userName.replace(/ {2}/, " "), mainData[z].form[totalI].division || "Off Work", outsideRoleCode[mainData[z].outside] || "");
                const jobs = mainData[z].form[totalI].data.filter(
                    d => d.category !== "lunch"
                );
                arr.push(mainData[z].form[totalI].mobInTimePM, mainData[z].form[totalI].mobInReg, mainData[z].form[totalI].mobInOT);
                arr.push(mainData[z].form[totalI].mobOutTimePM, mainData[z].form[totalI].mobOutReg, mainData[z].form[totalI].mobOutOT);
                if(mainData[z].outside === "locator"){
                    if(totalI > 4 || outsideHolidays.map(h => h.date).includes(getDatefromWeekNum(week, totalI))){
                        for(let jobi = 0; jobi < jobs.length; jobi++){
                            const hours = round((jobs[jobi].mins || 0) / 60, 2);
                            if(
                                jobs[jobi].category === "event" && 
                                !jobs[jobi].pmNumber
                        ){
                                arr.push(jobs[jobi].event || jobs[jobi].comment); // jobs[jobi].comment or defaultEmptyPMNumber
                                events.push([2 + z, 3 * jobi + 10]);
                            }else{
                                arr.push(jobs[jobi].pmNumber);
                            }
                            arr.push("");
                            arr.push(hours);
                        }
                        rows.push(arr);
                    }else{
                        let total = 0;
                        for(let jobi = 0; jobi < jobs.length; jobi++){
                            const hours = round((jobs[jobi].mins || 0) / 60, 2);
                            if(
                                jobs[jobi].category === "event" && 
                                !jobs[jobi].pmNumber
                            ){
                                if(isDevMode){
                                    console.log("event", totalI, 2 + z, 3 * jobi + 4);
                                }
                                arr.push(jobs[jobi].event || jobs[jobi].comment);
                                events.push([2 + z, 3 * jobi + 10]);
                            }else{
                                if(jobs[jobi].pmNumber === defaultEmptyPMNumber){
                                    events.push([2 + z, 3 * jobi + 10]);
                                    arr.push(
                                        jobs[jobi].event || 
                                        jobs[jobi].comment
                                    );
                                }else{
                                    arr.push(jobs[jobi].pmNumber);
                                }
                            }
                            if(
                                isDevMode && 
                                jobs[jobi].category === "job" && 
                                jobs[jobi].pmNumber === defaultEmptyPMNumber
                            ){
                                console.log("ticket", totalI, 2 + z, 3 * jobi + 4);
                            }
                            if(total <= 8 && total + hours >= 8){
                                arr.push(8 - total, hours - (8 - total));
                            }else if(total <= 8){
                                arr.push(hours, "");
                            }else if(total > 8){
                                arr.push("", hours);
                            }
                            total += hours;
                        }
                        rows.push(arr);
                    }
                }else{
                    for(let jobi = 0; jobi < jobs.length; jobi++){
                        if(
                            jobs[jobi].category === "event" && 
                            !jobs[jobi].pmNumber
                    ){
                            arr.push(jobs[jobi].event || jobs[jobi].comment); // jobs[jobi].comment or defaultEmptyPMNumber
                            events.push([2 + z, 3 * jobi + 10]);
                        }else{
                            arr.push(jobs[jobi].pmNumber);
                        }
                        if(jobs[jobi].regular){
                            arr.push(jobs[jobi].regular);
                        }else{
                            arr.push("");
                        }
                        if(jobs[jobi].ot){
                            arr.push(jobs[jobi].ot);
                        }else{
                            arr.push("");
                        }
                    }
                    rows.push(arr);
                }
            }
            //-------------------------------------------
            worksheet.addTable({
                name: `MyTable${totalI}`,
                ref: "A1",
                headerRow: true,
                style: {
                  theme: "TableStyleMedium9",
                  showRowStripes: true,
                },
                columns: headerArr.map(h => 
                  ({name: h,  filterButton: true})
                ),
                rows: rows,
              });
              events.forEach(e => {
                worksheet.getCell(...e).style = {
                    fill: {
                        type: "pattern", 
                        pattern:"solid", 
                        fgColor:{argb:"FFFF00"}
                    }
                }
            })
            //-------------------------------------------
            worksheet.columns.forEach(column => {
                const minLength = 18;
                let maxLength = 0;
                column["eachCell"]({ includeEmpty: true }, cell => {
                    cell.numFmt = "0.00";
                    const columnLength = cell.value?
                    cell.value.toString().length * (
                        cell.font?
                        cell.font.size / 11 * 1.2
                        :
                        1.3
                    )
                    :minLength;
                    if(columnLength > maxLength){
                        maxLength = columnLength;
                    }
                });
                column.width = maxLength < minLength ? minLength : maxLength;
            });
        }
        //-------------------------------------------
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx }), 
            `PM Report ${week}.xlsx`);
            setShowLoader(false);
        });
    }
    //--------------------------------------------------------------------------------------------
    return(
        <span className = "pointer" onClick = {handlePMReport}>PM Report</span>
    )
}